import PageShell from "@/components/layout/PageShell";
import DeliveryStaffSection from "@/components/DeliveryStaffSection";

export default function MasterDeliveryStaffPage() {
  return (
    <PageShell
      title="Delivery Staff"
      subtitle="Field agents, drivers, loaders, supervisors and managers · assigned to pickups & deliveries"
      overline="Master · Delivery Staff"
    >
      <DeliveryStaffSection />
    </PageShell>
  );
}
